var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-logo-gifas';
                    var viewUrl = 'sprite.svg#view-icon-logo-gifas';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-logo-gifas#icon-logo-gifas';
                            viewUrl = 'sprite.svg?icon-logo-gifas#view-icon-logo-gifas';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 195.382 52.229',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };